<template>
  <div :class="`${home ? 'avatar-home' : ''}`">
    <vs-avatar :size="size" circle>
      <img
        :src="src"
      >
    </vs-avatar>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  name: 'Avatar',
  data: function () {
    return {
      config: this.getConfig().config,
      homeInfo: {}
    }
  },
  mounted: function () {
    if (Cookies.get('homeInfo') !== null && Cookies.get('homeInfo') !== undefined) {
      this.homeInfo = JSON.parse(Cookies.get('homeInfo'))
    }
  },
  props: [
    'size',
    'home',
    'src'
  ]
}
</script>

<style scoped>
.avatar-home .vs-avatar, .avatar-home .vs-avatar-content {
  min-width: 200px !important;
  min-height: 200px !important;
}
</style>
